<template>
  <v-container>
    <v-card class="mt-4 pl-2">
      <v-row>
        <v-col cols="12"><h1>Пользователи</h1></v-col>
        <users-table />
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import UsersTable from "@/components/AdminUsersTable.vue";
import { CONSTS } from "../services/constants.js";

export default {
  mounted() {
    if (this.havePriv) {
      this.$store.dispatch("GetUsers");
    } else {
      this.$router.push("/");
    }
  },
  components: {
    UsersTable,
  },
  data: () => ({}),
  computed: {
    havePriv() {
      return !!this.$store.getters.StateUser.indicators[
        CONSTS.PRIVS_KEYS.users_admin
      ];
    },
  },
  methods: {},
  watch: {
    "$route.path": function () {
      console.log(this.$route.name);
    },
  },
};
</script>
